<template>
    <div>
        <ul class="space-y-4">
            <li v-for="ct in contactInfo" :key="ct.text" class="flex items-start gap-3">
                <i :class="ct.icon" class="mt-1 text-[#009d66] text-lg w-5 text-center shrink-0"></i>
                <span class="text-sm text-gray-600 leading-tight">{{ ct.text }}</span>
            </li>
        </ul>

        <!--
        <template v-if="documentsCMS && documentsCMSFiltered.length">
             <h4 class="text-sm font-bold uppercase tracking-wide text-gray-800 mt-6 mb-3">
                {{ $t('review_legal_documents') }}
            </h4>

            <ul class="space-y-2">
                <li v-for="doc in documentsCMSFiltered" :key="doc.title" 
                    @click="downloadPdf(doc.url)" 
                    class="flex items-center gap-2 cursor-pointer group">
                    <i :class="doc.icon" class="text-gray-400 group-hover:text-primary transition-colors text-base w-5 text-center shrink-0"></i>
                    <span class="text-sm text-gray-600 group-hover:text-primary transition-colors hover:underline">{{ doc.title }}</span>
                </li>
            </ul>
        </template>
        -->

        <div class="mt-8">
            <h4 class="text-sm font-bold uppercase tracking-wide text-gray-800 mb-3">
                {{ $t('review_legal_documents') }}
            </h4>
            <ul class="space-y-2">
                <li v-for="doc in legalDocsByLang" :key="doc.title" @click="downloadPublicPdf(doc.url)" class="flex items-center gap-2 cursor-pointer group">
                    
                    <i :class="doc.icon" class="text-gray-400 group-hover:text-[#009d66] transition-colors text-base w-5 text-center shrink-0"></i>
                    <span class="text-sm text-gray-600 group-hover:text-[#009d66] transition-colors hover:underline">{{ doc.title }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
// Download PDF from public/pdf directory
function downloadPublicPdf(url) {
    // Use fetch to check if the file exists, then trigger download
    fetch(url, { method: 'HEAD' })
        .then(res => {
            if (res.ok) {
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', url.split('/').pop());
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                alert('File not found.');
            }
        })
        .catch(() => alert('File not found.'));
}
import { computed } from 'vue';

// Map language to suffix for EN, FR, NL, etc.
const langSuffixMap = {
    'en_GB': 'EN',
    'de_DE': 'EN',
    'es_ES': 'EN',
    'sv_SE': 'EN',
    'it_IT': 'EN',
    'pl_PL': 'EN',
    'fr_BE': 'EN',
    'nl_BE': 'EN',
};

const legalDocFiles = {
    cookie_policy: {
        EN: 'CLD_Distribution_Cookie_Policy_EN.pdf',
        FR: 'CLD_Distribution_Cookie_Policy_FR.pdf',
        NL: 'CLD_Distribution_Cookie_Policy_NL.pdf',
    },
    privacy_policy: {
        EN: 'CLD_Distribution_Privacy_Policy_EN.pdf',
        FR: 'CLD_Distribution_Privacy_Policy_FR.pdf',
        NL: 'CLD_Distribution_Privacy_Policy_NL.pdf',
    },
    terms_of_use: {
        EN: 'CLD_Distribution_Terms_Of_Use_EN.pdf',
        FR: 'CLD_Distribution_Terms_Of_Use_FR.pdf',
        NL: 'CLD_Distribution_Terms_Of_Use_NL.pdf',
    },
};

const legalDocIcons = {
    cookie_policy: 'fa fa-info-circle',
    privacy_policy: 'fa fa-lock',
    terms_of_use: 'fa fa-file-text-o',
};

const legalDocsByLang = computed(() => {
    const lang = selectedLanguage.value;
    const suffix = langSuffixMap[lang] || 'EN';
    const legalDocTitles = {
        cookie_policy: t('cookie_policy'),
        privacy_policy: t('privacy_policy'),
        terms_of_use: t('terms_of_use'),
    };
    return ['cookie_policy', 'privacy_policy', 'terms_of_use'].map(key => {
        const file = legalDocFiles[key][suffix] || legalDocFiles[key]['EN'];
        return {
            title: legalDocTitles[key],
            icon: legalDocIcons[key],
            url: `/pdf/${file}`,
        };
    });
});
import { useCmsStore } from '~/store/cms/cmsStore';
import { useUtilityStore } from '~/store/UtililityStore';

const cmsStore = useCmsStore();
const utilityStore = useUtilityStore();
const selectedLanguage = computed(() => utilityStore.selectedLanguage);
const { t } = useI18n();
const documentsCMS = computed(() => cmsStore.legalDocuments.map(doc => ({
    ...doc,
    title: iconKey[doc.name]?.t || doc.name.replace(".pdf", ''),
    icon: iconKey[doc.name]?.icon || 'fa fa-file-text-o',

})));

// TODO DO LOCALIZATION OF LEGAL DOCS ON CMS SIDE
const documentsCMSFiltered = computed(() => documentsCMS.value.filter(doc => {
    const docName = documentsCMSLocalized[selectedLanguage.value];
    if (x.includes(doc.name)) {
        if (doc.name === docName) {
            return true;
        }
    }
    else if (!x.includes(doc.name)) {

        return true;
    }
    return false;
}));


const x = [
    'Conditions générales de vente CLD distribution SA - FR.2026.pdf',
    'General conditions of sales for CLD distribution SA-EN-2026.pdf', 'Algemene verkoopvoorwaarden van CLD distribution SA - NL-2026.pdf'
]
const documentsCMSLocalized = {
    "fr_BE": 'Conditions générales de vente CLD distribution SA - FR.2026.pdf',
    "en_GB": 'General conditions of sales for CLD distribution SA-EN-2026.pdf',
    "de_DE": 'General conditions of sales for CLD distribution SA-EN-2026.pdf',
    "nl_BE": 'Algemene verkoopvoorwaarden van CLD distribution SA - NL-2026.pdf',
    "es_ES": 'General conditions of sales for CLD distribution SA-EN-2026.pdf',
    "sv_SE": 'General conditions of sales for CLD distribution SA-EN-2026.pdf',
    "it_IT": 'General conditions of sales for CLD distribution SA-EN-2026.pdf',
    "pl_PL": 'General conditions of sales for CLD distribution SA-EN-2026.pdf'
}
const contactInfo = [
    {
        icon: 'fa fa-map-marker',
        text: 'CLD warehouse, Rue du Grand Champs 14, 5380 Fernelmont, Belgium'
    },
    {
        icon: 'fa fa-phone',
        text: `${t("call_us")}: +32 (0) 818-302-02`
    },
    {
        icon: 'fa fa-envelope',
        text: `${t("email_us")}: infos@cld.be`
    }]


const iconKey = {
    'Politiquedecookies.CLDDistribution.pdf': { t: t('cookie_policy'), icon: 'fa fa-info-circle' },
    'Politiquedeconfidentalité.CLDDistribution.pdf': { t: t('privacy_policy'), icon: 'fa fa-lock' },
    'CGU.CLDDistribution.pdf': { t: t('terms_of_use'), icon: 'fa fa-file-text-o' },
    //'Conditions générales de vente CLD distribution SA - FR.2025.pdf': { t: t('general_terms_of_sale_cld_distribution'), icon: 'fa fa-file-pdf-o' },
    'Algemene verkoopvoorwaarden van CLD distribution SA - NL-2026.pdf': { t: t('general_terms_of_sale_cld_distribution'), icon: 'fa fa-file-pdf-o' },
    'Conditions générales de vente CLD distribution SA - FR.2026.pdf': { t: t('general_terms_of_sale_cld_distribution'), icon: 'fa fa-file-pdf-o' },
    'General conditions of sales for CLD distribution SA-EN-2026.pdf': { t: t('general_terms_of_sale_cld_distribution'), icon: 'fa fa-file-pdf-o' },
};

const openPdf = (url) => {

    window.open(cmsStore.getImageUrl(url), '_blank');
};


const downloadPdf = (url) => {

    const docName = documentsCMSLocalized[selectedLanguage.value];
    if (documentsCMSLocalized) {
        const localizedDoc = documentsCMS.value.find(doc => doc.name === docName);
        if (localizedDoc) {
            url = localizedDoc.url;
        }

    }

    cmsStore.downloadPdf(url);
}

</script>
